export type OfferFeature = {
  label: string
  bold?: boolean
}

export const offer = {
  name: 'The Calm Mornings Mega Kit',
  compareAt: 60,
  price: 27.99,
  savePercent: 50,
  features: [
    { label: 'The Calm Mornings System — 10+ visual routines, boards, time tracker' },
    { label: 'All 12 bonuses (worth $184 — see them below ↓)' },
    { label: 'Free updates for life', bold: true },
  ] as OfferFeature[],
}
